<template>
    <eds-create v-if="displayEds" ref="edsCreateDialog" @mounted="onMountedEdsCreate" />
</template>

<script>
export default {
  components: { 
    'eds-create': () => import('@it-enterprise/web-app-common/src/widgets/dr-eds/components/eds-create/EdsCreate.vue')
  },
  data: () => ({
    displayEds: false
  }),
  methods: {
    onMountedEdsCreate() {
      this.$options.resolveFunction()
    },
    async signFile(file) {
      await this.getEdsCreateDialogRef()
      return await this.$refs.edsCreateDialog.signFile(file)
    },
    getEdsCreateDialogRef() {
      return new Promise((resolve) => {
        this.displayEds = true
        if (this.$refs.edsCreateDialog) {
          resolve()
          return
        }
        this.$options.resolveFunction = resolve
      })
    }
  },
  mounted() {
    this.$emit('mounted')
  }
}
</script>
<style lang="scss">

</style>